import type { ComponentProps } from "react"
import { formatDateTime } from "@/v2-common/utils/utils.date"
import cn from "@/v2-ui/utils/utils.cn"
import InvitationLogStatus from "@/v2-backoffice-client/invitation/log/InvitationLogStatus"
import type { InvitationLogFragment } from "@/v2-backoffice-client/invitation/log/__types__/invitation.log.fragment"

export type InvitationLogListProps = ComponentProps<"div"> & {
  logs: InvitationLogFragment[] | null | undefined
}

function InvitationLogList(props: InvitationLogListProps) {
  const { logs, className, ...divProps } = props

  if (!logs || logs.length === 0) {
    return (
      <div className={cn("invitation-log-empty", className)} {...divProps}>
        No activity yet
      </div>
    )
  }

  return (
    <div className={cn("invitation-log-list", className)} {...divProps}>
      {logs.map((log) => {
        return (
          <div key={log.Id} className="invitation-log-item">
            <InvitationLogStatus log={log} /> —
            <span className="invitation-log-timestamp">
              {formatDateTime(new Date(log.CreatedAt))}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default InvitationLogList
